import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  transactions: [],
  total: 0,
  pdf: undefined,
  onhand: 0
}

// getters
export const getters = {
  transactions: state => state.transactions,
  total: state => state.total,
  pdf: state => state.pdf,
  onhand: state => state.onhand
}

// mutations
export const mutations = {

  TRANSACTIONS_DATA (state, data) {
    state.transactions = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  PDF (state, data) {
    state.pdf = data
  },

  ONHAND (state, data) {
    state.onhand = data
  }
}

// actions
export const actions = {

  async fetchAll ({ commit }, { filterData }) {
    const { data } = await axios.get(laroute.route('transaction_history', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('TRANSACTIONS_DATA', data.items)
    commit('ONHAND', data.on_hand)
  },

  async generatePDF ({ commit }, { filterData, items, onhand }) {
    const { data } = await axios.post(laroute.route('transaction_history_pdf', { companyAbbr: store.getters['auth/company'] }), { filterData, items, onhand }, { responseType: 'arraybuffer' })
    commit('PDF', data)
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/transactionHistory.js